// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b451c4ba","952":"5529ae52"}[chunkId] + ".chunk.js";
};